<template>
  <div>
    <b-breadcrumb>
      <b-breadcrumb-item to="/home" @click="updateListCategory('listCategoryHome')">Home</b-breadcrumb-item>
      <b-breadcrumb-item href="#today" active>Today</b-breadcrumb-item>
    </b-breadcrumb>
    <h1 class="template-name">Today</h1>
    <p>Take a look at your tasks for today.</p>
    <b-tabs content-class="mt-3" active-nav-item-class="font-weight-bold">
      <b-tab title="Personal List" active>
        <div class="task-container">
          <div v-if="showPlaceholderImagePersonal && !hideWhenInitialLoadPersonal" class="no-task-container">
            <b-img class="no-task-picture" :src="require('../../assets/no_task.png')"
                   alt="No task picture"></b-img>
            <h2>No task due today</h2>
            <p>Today is going to be a good day!</p>
          </div>
          <regular-with-origin-task-cell v-else v-for="todayTask in personalTodayTaskDocuments" :key="todayTask.taskId"
                                         :task-details="todayTask"></regular-with-origin-task-cell>
        </div>
      </b-tab>
      <b-tab title="Collaborative List">
        <div class="task-container">
          <div v-if="showPlaceholderImageCollaborative && !hideWhenInitialLoadCollaborative" class="no-task-container">
            <b-img class="no-task-picture" :src="require('../../assets/no_task.png')"
                   alt="No task picture"></b-img>
            <h2>No task due today</h2>
            <p>Today is going to be a good day!</p>
          </div>
          <regular-with-origin-task-cell v-else v-for="todayTask in collaborativeTodayTaskDocuments" :key="todayTask.taskId"
                                         :task-details="todayTask"></regular-with-origin-task-cell>
        </div>
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
  import RegularWithOriginTaskCell from "../table_cells/task_cells/RegularWithOriginTaskCell"
  import {mapActions, mapGetters} from "vuex";
  import {db} from "../../main";
  import firebase from "firebase";

  export default {
    data() {
      return {
        showPlaceholderImagePersonal: null,
        showPlaceholderImageCollaborative: null,
        hideWhenInitialLoadPersonal: true,
        hideWhenInitialLoadCollaborative: true,
        personalTodayTaskDocuments: null,
        collaborativeTodayTaskDocuments: null
      }
    },
    components: {
      regularWithOriginTaskCell: RegularWithOriginTaskCell
    },
    methods: {
      ...mapActions([
        "updateListCategory"
      ]),
      getTodayTaskData() {
        const date = new Date()
        date.setHours(0, 0, 0,0)

        const currentDate = firebase.firestore.Timestamp.fromDate(date)

        date.setDate(date.getDate() + 1)

        const endDate = firebase.firestore.Timestamp.fromDate(date)

        this.$bind(
          'personalTodayTaskDocuments',
          db
            .collectionGroup('tasks')
            .where('assigneeId', '==', this.$store.getters.user.data.id)
            .where('taskType', '==', 'Personal Task')
            .where('dueDate', '>=', currentDate)
            .where('dueDate', '<', endDate)
            .orderBy('dueDate', 'asc')
        ).then(() => {
          if (this.personalTodayTaskDocuments.length === 0) {
            this.showPlaceholderImagePersonal = true
          }
          this.hideWhenInitialLoadPersonal = false
        })

        this.$bind(
          'collaborativeTodayTaskDocuments',
          db
            .collectionGroup('tasks')
            .where('assigneeId', '==', this.$store.getters.user.data.id)
            .where('taskType', '==', 'Collaborative Task')
            .where('dueDate', '>=', currentDate)
            .where('dueDate', '<=', endDate)
            .orderBy('dueDate', 'asc')
        ).then(() => {
          if (this.collaborativeTodayTaskDocuments.length === 0) {
            this.showPlaceholderImageCollaborative = true
          }
          this.hideWhenInitialLoadCollaborative = false
        })
      }
    },
    watch: {
      personalTodayTaskDocuments(newProperties, oldProperties) {
        this.showPlaceholderImagePersonal = this.personalTodayTaskDocuments.length === 0
      },
      collaborativeTodayTaskDocuments(newProperties, oldProperties) {
        this.showPlaceholderImageCollaborative = this.collaborativeTodayTaskDocuments.length === 0
      },
    },
    mounted() {
      this.getTodayTaskData()
    }
  }
</script>

<style scoped>
  .no-task-container {
    text-align: center;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  .no-task-picture {
    width: 375px;
    margin-bottom: 1em;
  }

  .template-name {
    font-size: 2em;
    margin-bottom: 0.5em;
  }

  .task-container {
    height: 65vh;
    overflow-y: auto;
    overflow-x: hidden;
    position: relative;
  }
</style>
